module.exports = __webpack_public_path__ + "img/charging-hub-realized-private.6261492a.svg";